import {tv} from 'tailwind-variants'

export const hgArticleListingMiniVariants = tv({
  slots: {
    wrapper: 'flex w-full gap-x-s3 xl:max-w-[448px]',
    imageWrapper: 'min-w-[80px] max-w-[80px]',
  },
})
